import type { FunctionComponent } from 'react';
import cx from 'classnames';
import { useSubnavContext } from './context';
import { RouterLink } from '../Link';
import styles from './Subnav.module.less';

export type DropdownItemProps = {
  to: string;
  navKey: string;
};

export type DropdownItemComponent = FunctionComponent<DropdownItemProps>;

/**
 * Represents an individual item in the dropdown menu.
 * Not intended to be used directly, see examples below.
 */
const SubnavDropdownItem: DropdownItemComponent = ({
  to,
  navKey,
  children,
}) => {
  const { activeKey } = useSubnavContext();
  return (
    <RouterLink
      key={navKey}
      to={to}
      className={cx(styles.dropdownLink, {
        [styles.dropdownLinkActive]: activeKey && activeKey === navKey,
      })}
      tabIndex={0}
      role="menuitem"
    >
      {children}
    </RouterLink>
  );
};

export default SubnavDropdownItem;
